import { CalendarPage } from './pages';

export const calendarRoutes = [
  {
    path: 'calendar',
    component: CalendarPage,
    requiredPermission: 'calendar.view',
  },
];
